import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    // Navigation
    home: "Home",
    aboutUs: "About Us",
    products: "Products",
    sustainability: "Sustainability",
    quality: "Quality",
    news: "News",
    contact: "Contact",
    
    // Private Area
    privateArea: "Private Area",
    privateTransporters: "Transporters",
    privatePurchases: "Purchases",
    privateEcommerce: "E-Commerce",
    privateClients: "Clients",
    privateLogin: "Private Area Login",
    privateLoginSubtitle: "Access your account",
    username: "Username",
    password: "Password",
    login: "Login",
    logout: "Logout",
    loginError: "Invalid credentials",
    welcome: "Welcome",
    userManagement: "User Management",
    createUser: "Create User",
    userList: "User List",
    userType: "User Type",
    actions: "Actions",
    delete: "Delete",
    userCreated: "User created successfully",
    userDeleted: "User deleted successfully",
    confirmDelete: "Are you sure you want to delete this user?",
    noUsers: "No users found",
    adminPanel: "Admin Panel",
    backToPortal: "Back to Portal",
    
    // Hero
    heroSlide1: "30 years transforming steel for construction in Europe",
    heroSlide2: "Technology, capacity and reliability in every meter of steel",
    heroSlide3: "Optimized logistics for fast and secure deliveries",
    heroSlide4: "Building the future together with our customers",
    heroSlide5: "Sustainability as a pillar of our industry",
    ourProducts: "Our Products",
    talkToSpecialist: "Talk to a Specialist",
    
    // About
    aboutTitle: "About TRH Steel",
    aboutSubtitle: "European steel, sustainable commitment",
    aboutDescription: "TRH is an industrial group specialized in steel transformation for the production of welded mesh and related products. We operate two production plants strategically located in Southern and Northern Europe, allowing us to ensure reliable and efficient supply to our customers.",
    ourPresence: "Our Industrial Presence",
    plants: "Production Plants",
    productionLines: "Production Lines",
    annualCapacity: "Annual Capacity",
    tons: "tons",
    marketsServed: "Markets Served",
    ourValues: "Our Values",
    reliability: "Reliability",
    reliabilityDesc: "Consistent supply and on-time delivery performance.",
    consistency: "Quality",
    consistencyDesc: "Products that consistently meet market standards.",
    flexibility: "Flexibility",
    flexibilityDesc: "Ability to adapt to specific customer and project requirements.",
    longTermVision: "Commitment",
    longTermVisionDesc: "Customer-oriented approach and continuous process improvement.",
    
    // Products
    productsTitle: "Our Products",
    productsSubtitle: "Steel solutions for construction",
    allFamilies: "All Families",
    allCountries: "All Countries",
    specifications: "Specifications",
    downloadDatasheet: "Download Datasheet",
    viewDetails: "View Details",
    
    // Sustainability
    sustainabilityTitle: "Sustainability",
    sustainabilitySubtitle: "TRH Steel, committed to a more efficient and circular steel industry",
    renewableEnergy: "Renewable Energy",
    renewableEnergyDesc: "Our plants operate with 30% renewable energy sources.",
    productOptimization: "Product Optimization",
    productOptimizationDesc: "Maximizing material efficiency in every production process.",
    responsibleMaterials: "Responsible Raw Materials",
    responsibleMaterialsDesc: "Sourcing materials from certified and ethical suppliers.",
    wasteManagement: "Waste Management & Circularity",
    wasteManagementDesc: "Implementing closed-loop recycling systems.",
    efficientLogistics: "Efficient Logistics",
    efficientLogisticsDesc: "Optimized routes and consolidated shipments.",
    compliance: "Regulatory Compliance",
    complianceDesc: "Meeting and exceeding environmental standards.",
    
    // Quality
    qualityTitle: "Quality",
    qualitySubtitle: "Quality is an integrated process, not just certification",
    qualityPolicy: "Quality Policy",
    qualityPolicyDesc: "Our commitment to excellence drives every aspect of our operations, from raw material selection to final delivery.",
    controlTraceability: "Control & Traceability",
    controlTraceabilityDesc: "Complete product traceability from origin to delivery with real-time tracking systems.",
    testingLabs: "Internal Laboratories",
    testingLabsDesc: "Continuous control from raw material to final product, ensuring compliance with required standards.",
    continuousImprovement: "Continuous Improvement",
    continuousImprovementDesc: "Ongoing optimization of processes and systems to deliver better results.",
    ourCertificates: "Our Certificates",
    corporateCertificates: "Corporate Certificates",
    productCertificates: "Product Certificates",
    validUntil: "Valid until",
    
    // News
    newsTitle: "News",
    newsSubtitle: "Latest updates from TRH Steel",
    readMore: "Read More",
    
    // News Management (Admin)
    newsManagement: "News Management",
    importDefaults: "Import Defaults",
    newArticle: "New Article",
    editArticle: "Edit Article",
    noNewsInDb: "No news articles in the database.",
    clickImportDefaults: 'Click "Import Defaults" to add the sample news.',
    titleColumn: "Title",
    categoryColumn: "Category",
    dateColumn: "Date",
    statusColumn: "Status",
    actionsColumn: "Actions",
    noTitle: "No title",
    published: "Published",
    draft: "Draft",
    articleTitle: "Title",
    articleTitlePlaceholder: "Article title",
    articleSummary: "Summary",
    articleSummaryPlaceholder: "Brief summary of the article",
    articleContent: "Content",
    articleContentPlaceholder: "Full article content",
    publicationDate: "Publication Date",
    author: "Author",
    authorPlaceholder: "Author name",
    newsImages: "Article Images",
    uploadingImage: "Uploading image...",
    clickToUploadImages: "Click to attach images",
    imageFormats: "PNG, JPG, WEBP (max 5MB)",
    setAsMainImage: "Set as main image",
    deleteImage: "Delete image",
    mainImage: "Main",
    cancel: "Cancel",
    saveChanges: "Save Changes",
    createArticle: "Create Article",
    
    // Contact
    contactTitle: "Contact",
    contactSubtitle: "Get in touch with our team",
    generalInquiries: "General Inquiries",
    sendMessage: "Send Message",
    yourName: "Your Name",
    yourEmail: "Your Email",
    company: "Company",
    country: "Country",
    phone: "Phone",
    subject: "Subject",
    message: "Message",
    selectCountry: "Select a country",
    ourLocations: "Our Locations",
    messageSent: "Message sent successfully!",
    messageError: "Error sending message. Please try again.",
    joinOurTeam: "Join Our Team",
    joinOurTeamDesc: "We are always looking for talented professionals to strengthen our industrial team across Europe.",
    cvUpload: "Upload CV",
    cvUploadHint: "PDF, DOC or DOCX (max 5MB)",
    sendApplication: "Send Application",
    applicationSent: "Application sent successfully!",
    applicationError: "Error sending application. Please try again.",
    transportPartners: "Are You a Transport Partner?",
    transportPartnersDesc: "We collaborate with transport companies across Europe to ensure reliable delivery of our steel products.",
    companyName: "Company Name",
    contactPerson: "Contact Person",
    coverageArea: "Coverage Area",
    coverageAreaPlaceholder: "e.g. Spain, France, Benelux...",
    fleetDescription: "Fleet Description",
    fleetDescriptionPlaceholder: "Number of vehicles, types, capacity...",
    becomePartner: "Become a Transport Partner",
    partnerSent: "Partner application sent successfully!",
    partnerError: "Error sending application. Please try again.",
    loadingHours: "Loading Hours",
    loadingHoursDesc: "Our facilities are open for loading during the following hours:",
    
    // Footer
    footerTagline: "European steel, sustainable commitment. More than 30 years building together.",
    legalNotice: "Legal Notice",
    privacyPolicy: "Privacy Policy",
    cookies: "Cookies Policy",
    generalTerms: "General Terms",
    allRightsReserved: "All rights reserved",
    
    // Chatbot
    chatbotTitle: "TRH Steel Assistant",
    chatbotPlaceholder: "Ask about our products, services...",
    chatbotWelcome: "Hello! I'm the TRH Steel virtual assistant. How can I help you today?",
    
    // Countries
    spain: "Spain",
    portugal: "Portugal",
    france: "France",
    belgium: "Belgium",
    netherlands: "Netherlands",
    germany: "Germany",
    
    // Home Page Stats
    yearsExperience: "Years of Experience",
    
    // Products Page
    weldedMesh: "Welded Mesh",
    newBadge: "NEW",
    filter: "Filter",
    productTableProduct: "Product",
    productTableFamily: "Family",
    productTableCountries: "Countries",
    productTableStandard: "Standard",
    productTableActions: "Actions",
    details: "Details",
    availableIn: "Available in",
    close: "Close",
    
    // Country Selector
    selectCountryTitle: "Select your country to view available products",
    productAvailabilityNote: "Product availability varies by market",
    selectYourCountry: "Select your country",
    selectedCountry: "Selected country",
    changeCountry: "Change country",
    clearSelection: "Clear selection",
    availableProductsIn: "Available products in",
    allProductCategories: "All Product Categories",
    selectCountryToFilter: "Select a country above to filter products by availability",
    noProductsAvailable: "No products available for this selection",
    comingSoon: "Coming Soon",
    placeholderProductNote: "This product category will be available soon. Leave your details and we will contact you.",
    
    // Footer
    legal: "Legal",
    
    // Quality Page - Every Meter Tested
    everyMeterTested: "Quality Control",
    everyMeterTestedDesc: "We operate internal laboratories where continuous control is carried out from raw material to final product, ensuring that our products meet the required quality standards.",
    tensileTesting: "Tensile Testing",
    chemicalAnalysis: "Chemical Analysis",
    dimensionalCheck: "Dimensional Check",
    batchTraceability: "Batch Traceability",
    
    // Cookie Policy
    optional: "Optional",
    required: "Required",
    retention: "Retention",
    
    // Legal Notice
    legalName: "Legal Name",
    
    // Quality Page - dates
    undefined: "Undefined",
    
    // Home Page - Contact CTA
    readyToWork: "Ready to Work Together?",
    whyTrhSteel: "Why TRH Steel",
    whyTrhSteelDesc: "A European industrial steel group with a clear structure and long-term vision.",
    sustainabilityHomeDesc: "Our commitment to sustainability drives every aspect of our operations, from renewable energy usage to waste management and efficient logistics.",
    circularEconomy: "Circular Economy",
    circularEconomyDesc: "Closed-loop recycling and waste management systems",
    since: "Since",
    catalogTitle: "Corporate Catalog",
    catalogNav: "Catalog",
    catalogDescription: "Download our corporate catalog with complete product information, technical specifications and certifications. Available in 5 languages.",
    downloadPdf: "Download",
    readyToWorkDesc: "Contact our team of specialists to discuss your steel requirements.",
    
    // About Page
    strategicFacilities: "Strategic production facilities serving key European markets.",
    productionPlant: "Production Plant",
    ourHistory: "Our History",
    historyFounded: "Founded",
    historyFoundedDesc: "TRH Steel established in Seville, Spain",
    historyExpansion: "Expansion",
    historyExpansionDesc: "First major production line expansion",
    historyBelgium: "Belgium",
    historyBelgiumDesc: "Opened Liège production facility",
    historySustainability: "Sustainability",
    historySustainabilityDesc: "Achieved 100% renewable energy",
    historyToday: "Today",
    historyTodayDesc: "8 production lines, 400K tons capacity",
    
    // Sustainability Page - Stat Labels
    renewable: "Renewable",
    wasteReduction: "Waste Reduction",
    certifiedSuppliers: "Certified Suppliers",
    recyclingRate: "Recycling Rate",
    co2Reduction: "CO2 Reduction",
    
    // Sustainability Page - Commitment Section
    ourCommitment: "Our Commitment",
    buildingSustainableFuture: "Building a Sustainable Future",
    sustainabilityCommitmentP1: "At TRH Steel, sustainability is not just a goal—it's a fundamental principle that guides every decision we make. From the energy we use to the materials we source, we are committed to minimizing our environmental impact while maximizing value for our customers.",
    sustainabilityCommitmentP2: "Our circular economy approach ensures that steel—an infinitely recyclable material—remains part of a closed-loop system, reducing waste and conserving natural resources for future generations.",
    carbonNeutral: "Carbon Neutral",
    
    // Sustainability Page - 2030 Goals
    our2030Goals: "Our 2030 Goals",
    goalsSubtitle: "Ambitious targets driving our sustainability journey.",
    co2ReductionGoal: "CO2 Reduction",
    from2020Baseline: "From 2020 baseline",
    circularSteel: "Circular Steel",
    recycledContentTarget: "Recycled content target",
    zeroWaste: "Zero",
    wasteToLandfill: "Waste to Landfill",
    fullCircularity: "Full circularity",
    
    // News Page
    categorySustainability: "Sustainability",
    categoryCorporate: "Corporate",
    categoryQuality: "Quality",
    categoryMarket: "Market",
    categoryProduct: "Product",
    byAuthor: "By",
    
    // Contact Page - Locations
    sevilleSpain: "Seville, Spain",
    sevilleLocationName: "TRH ZF Sevilla",
    liegeLocationName: "TRH Liege",
    liegeBelgium: "Liège, Belgium",
    sending: "Sending...",
    
    // Footer Locations
    footerSeville: "Seville, Spain",
    footerLiege: "Liège, Belgium",
    
    // Product Inquiry Modal
    productInquirySubtitle: "Request information about this product",
    thankYouTitle: "Thank you!",
    thankYouMessage: "Your message has been sent successfully. We will contact you soon.",
  },
  es: {
    // Navigation
    home: "Inicio",
    aboutUs: "Nosotros",
    products: "Productos",
    sustainability: "Sostenibilidad",
    quality: "Calidad",
    news: "Noticias",
    contact: "Contacto",
    
    // Private Area
    privateArea: "Área Privada",
    privateTransporters: "Transportistas",
    privatePurchases: "Compras",
    privateEcommerce: "E-Commerce",
    privateClients: "Clientes",
    privateLogin: "Acceso Área Privada",
    privateLoginSubtitle: "Acceda a su cuenta",
    username: "Usuario",
    password: "Contraseña",
    login: "Entrar",
    logout: "Salir",
    loginError: "Credenciales inválidas",
    welcome: "Bienvenido",
    userManagement: "Gestión de Usuarios",
    createUser: "Crear Usuario",
    userList: "Lista de Usuarios",
    userType: "Tipo de Usuario",
    actions: "Acciones",
    delete: "Eliminar",
    userCreated: "Usuario creado correctamente",
    userDeleted: "Usuario eliminado correctamente",
    confirmDelete: "¿Está seguro de que desea eliminar este usuario?",
    noUsers: "No se encontraron usuarios",
    adminPanel: "Panel de Administración",
    backToPortal: "Volver al Portal",
    
    // Hero
    heroSlide1: "30 años transformando acero para la construcción en Europa",
    heroSlide2: "Tecnología, capacidad y fiabilidad en cada metro de acero",
    heroSlide3: "Logística optimizada para entregas rápidas y seguras",
    heroSlide4: "Construyendo el futuro junto a nuestros clientes",
    heroSlide5: "La sostenibilidad como pilar de nuestra industria",
    ourProducts: "Nuestros Productos",
    talkToSpecialist: "Hablar con un Especialista",
    
    // About
    aboutTitle: "Sobre TRH Steel",
    aboutSubtitle: "Acero europeo, compromiso sostenible",
    aboutDescription: "TRH es un grupo industrial especializado en la transformación de acero para la producción de malla electrosoldada y productos afines. Operamos dos plantas de producción estratégicamente ubicadas en el sur y norte de Europa, lo que nos permite garantizar un suministro fiable y eficiente a nuestros clientes.",
    ourPresence: "Nuestra Presencia Industrial",
    plants: "Plantas de Producción",
    productionLines: "Líneas de Producción",
    annualCapacity: "Capacidad Anual",
    tons: "toneladas",
    marketsServed: "Mercados Servidos",
    ourValues: "Nuestros Valores",
    reliability: "Fiabilidad",
    reliabilityDesc: "Suministro constante y cumplimiento de plazos de entrega.",
    consistency: "Calidad",
    consistencyDesc: "Productos que cumplen de forma consistente los estándares del mercado.",
    flexibility: "Flexibilidad",
    flexibilityDesc: "Capacidad de adaptación a los requisitos específicos de cada cliente y proyecto.",
    longTermVision: "Compromiso",
    longTermVisionDesc: "Orientación al cliente y mejora continua de procesos.",
    
    // Products
    productsTitle: "Nuestros Productos",
    productsSubtitle: "Soluciones de acero para la construcción",
    allFamilies: "Todas las Familias",
    allCountries: "Todos los Países",
    specifications: "Especificaciones",
    downloadDatasheet: "Descargar Ficha Técnica",
    viewDetails: "Ver Detalles",
    
    // Sustainability
    sustainabilityTitle: "Sostenibilidad",
    sustainabilitySubtitle: "TRH Steel, comprometido con una industria del acero más eficiente y circular",
    renewableEnergy: "Energía Renovable",
    renewableEnergyDesc: "Nuestras plantas operan con fuentes de energía 30% renovables.",
    productOptimization: "Optimización de Producto",
    productOptimizationDesc: "Maximizando la eficiencia de materiales en cada proceso de producción.",
    responsibleMaterials: "Materias Primas Responsables",
    responsibleMaterialsDesc: "Abastecimiento de materiales de proveedores certificados y éticos.",
    wasteManagement: "Gestión de Residuos y Circularidad",
    wasteManagementDesc: "Implementando sistemas de reciclaje de ciclo cerrado.",
    efficientLogistics: "Logística Eficiente",
    efficientLogisticsDesc: "Rutas optimizadas y envíos consolidados.",
    compliance: "Cumplimiento Normativo",
    complianceDesc: "Cumpliendo y superando los estándares ambientales.",
    
    // Quality
    qualityTitle: "Calidad",
    qualitySubtitle: "La calidad es un proceso integrado, no solo una certificación",
    qualityPolicy: "Política de Calidad",
    qualityPolicyDesc: "Nuestro compromiso con la excelencia impulsa cada aspecto de nuestras operaciones, desde la selección de materias primas hasta la entrega final.",
    controlTraceability: "Control y Trazabilidad",
    controlTraceabilityDesc: "Trazabilidad completa del producto desde el origen hasta la entrega con sistemas de seguimiento en tiempo real.",
    testingLabs: "Laboratorios Internos",
    testingLabsDesc: "Control continuo desde la materia prima hasta el producto final, garantizando el cumplimiento de los estándares requeridos.",
    continuousImprovement: "Mejora Continua",
    continuousImprovementDesc: "Optimización continua de procesos y sistemas para ofrecer mejores resultados.",
    ourCertificates: "Nuestros Certificados",
    corporateCertificates: "Certificados Corporativos",
    productCertificates: "Certificados de Producto",
    validUntil: "Válido hasta",
    
    // News
    newsTitle: "Noticias",
    newsSubtitle: "Últimas novedades de TRH Steel",
    readMore: "Leer Más",
    
    // News Management (Admin)
    newsManagement: "Gestión de Noticias",
    importDefaults: "Importar Predeterminadas",
    newArticle: "Nueva Noticia",
    editArticle: "Editar Noticia",
    noNewsInDb: "No hay noticias en la base de datos.",
    clickImportDefaults: 'Haz clic en "Importar Predeterminadas" para añadir las noticias de ejemplo.',
    titleColumn: "Título",
    categoryColumn: "Categoría",
    dateColumn: "Fecha",
    statusColumn: "Estado",
    actionsColumn: "Acciones",
    noTitle: "Sin título",
    published: "Publicada",
    draft: "Borrador",
    articleTitle: "Título",
    articleTitlePlaceholder: "Título de la noticia",
    articleSummary: "Resumen",
    articleSummaryPlaceholder: "Breve resumen de la noticia",
    articleContent: "Contenido",
    articleContentPlaceholder: "Contenido completo de la noticia",
    publicationDate: "Fecha de Publicación",
    author: "Autor",
    authorPlaceholder: "Nombre del autor",
    newsImages: "Imágenes de la Noticia",
    uploadingImage: "Subiendo imagen...",
    clickToUploadImages: "Haz clic para adjuntar imágenes",
    imageFormats: "PNG, JPG, WEBP (máx 5MB)",
    setAsMainImage: "Establecer como imagen principal",
    deleteImage: "Eliminar imagen",
    mainImage: "Principal",
    cancel: "Cancelar",
    saveChanges: "Guardar Cambios",
    createArticle: "Crear Noticia",
    
    // Contact
    contactTitle: "Contacto",
    contactSubtitle: "Póngase en contacto con nuestro equipo",
    generalInquiries: "Consultas Generales",
    sendMessage: "Enviar Mensaje",
    yourName: "Su Nombre",
    yourEmail: "Su Email",
    company: "Empresa",
    country: "País",
    phone: "Teléfono",
    subject: "Asunto",
    message: "Mensaje",
    selectCountry: "Seleccione un país",
    ourLocations: "Nuestras Ubicaciones",
    messageSent: "¡Mensaje enviado con éxito!",
    messageError: "Error al enviar el mensaje. Por favor, inténtelo de nuevo.",
    joinOurTeam: "Únete a Nuestro Equipo",
    joinOurTeamDesc: "Buscamos profesionales con talento para reforzar nuestro equipo industrial en toda Europa.",
    cvUpload: "Adjuntar CV",
    cvUploadHint: "PDF, DOC o DOCX (máx. 5MB)",
    sendApplication: "Enviar Candidatura",
    applicationSent: "¡Candidatura enviada con éxito!",
    applicationError: "Error al enviar la candidatura. Inténtelo de nuevo.",
    transportPartners: "¿Eres Transportista?",
    transportPartnersDesc: "Colaboramos con empresas de transporte en toda Europa para garantizar la entrega fiable de nuestros productos siderúrgicos.",
    companyName: "Nombre de la Empresa",
    contactPerson: "Persona de Contacto",
    coverageArea: "Zona de Cobertura",
    coverageAreaPlaceholder: "ej. España, Francia, Benelux...",
    fleetDescription: "Descripción de la Flota",
    fleetDescriptionPlaceholder: "Número de vehículos, tipos, capacidad...",
    becomePartner: "Ser Transportista Colaborador",
    partnerSent: "¡Solicitud de colaboración enviada con éxito!",
    partnerError: "Error al enviar la solicitud. Inténtelo de nuevo.",
    loadingHours: "Horarios de Carga",
    loadingHoursDesc: "Nuestras instalaciones están abiertas para carga en los siguientes horarios:",
    
    // Footer
    footerTagline: "Acero europeo, compromiso sostenible. Más de 30 años construyendo juntos.",
    legalNotice: "Aviso Legal",
    privacyPolicy: "Política de Privacidad",
    cookies: "Política de Cookies",
    generalTerms: "Condiciones Generales",
    allRightsReserved: "Todos los derechos reservados",
    
    // Chatbot
    chatbotTitle: "Asistente TRH Steel",
    chatbotPlaceholder: "Pregunte sobre nuestros productos, servicios...",
    chatbotWelcome: "¡Hola! Soy el asistente virtual de TRH Steel. ¿En qué puedo ayudarle hoy?",
    
    // Countries
    spain: "España",
    portugal: "Portugal",
    france: "Francia",
    belgium: "Bélgica",
    netherlands: "Países Bajos",
    germany: "Alemania",
    
    // Home Page Stats
    yearsExperience: "Años de Experiencia",
    
    // Products Page
    weldedMesh: "Malla Electrosoldada",
    newBadge: "NUEVO",
    filter: "Filtrar",
    productTableProduct: "Producto",
    productTableFamily: "Familia",
    productTableCountries: "Países",
    productTableStandard: "Norma",
    productTableActions: "Acciones",
    details: "Detalles",
    availableIn: "Disponible en",
    close: "Cerrar",
    
    // Country Selector
    selectCountryTitle: "Selecciona tu país para ver los productos disponibles",
    productAvailabilityNote: "La disponibilidad de productos varía según el mercado",
    selectYourCountry: "Selecciona tu país",
    selectedCountry: "País seleccionado",
    changeCountry: "Cambiar país",
    clearSelection: "Borrar selección",
    availableProductsIn: "Productos disponibles en",
    allProductCategories: "Todas las Categorías de Productos",
    selectCountryToFilter: "Selecciona un país arriba para filtrar productos por disponibilidad",
    noProductsAvailable: "No hay productos disponibles para esta selección",
    comingSoon: "Próximamente",
    placeholderProductNote: "Esta categoría de producto estará disponible pronto. Deja tus datos y te contactaremos.",
    
    // Footer
    legal: "Legal",
    
    // Quality Page - Every Meter Tested
    everyMeterTested: "Control de Calidad",
    everyMeterTestedDesc: "Operamos laboratorios internos donde se realiza un control continuo desde la materia prima hasta el producto final, garantizando que nuestros productos cumplen los estándares de calidad requeridos.",
    tensileTesting: "Ensayo de Tracción",
    chemicalAnalysis: "Análisis Químico",
    dimensionalCheck: "Control Dimensional",
    batchTraceability: "Trazabilidad de Lote",
    
    // Cookie Policy
    optional: "Opcional",
    required: "Requerido",
    retention: "Retención",
    
    // Legal Notice
    legalName: "Razón Social",
    
    // Quality Page - dates
    undefined: "Indefinido",
    
    // Home Page - Contact CTA
    readyToWork: "¿Listos para Trabajar Juntos?",
    whyTrhSteel: "Por qué TRH Steel",
    whyTrhSteelDesc: "Un grupo industrial siderúrgico europeo con una estructura clara y una visión a largo plazo.",
    sustainabilityHomeDesc: "Nuestro compromiso con la sostenibilidad impulsa cada aspecto de nuestras operaciones, desde el uso de energías renovables hasta la gestión de residuos y la logística eficiente.",
    circularEconomy: "Economía Circular",
    circularEconomyDesc: "Sistemas de reciclaje en circuito cerrado y gestión de residuos",
    since: "Desde",
    catalogTitle: "Catálogo Corporativo",
    catalogNav: "Catálogo",
    catalogDescription: "Descargue nuestro catálogo corporativo con información completa de productos, especificaciones técnicas y certificaciones. Disponible en 5 idiomas.",
    downloadPdf: "Descargar",
    readyToWorkDesc: "Contacte con nuestro equipo de especialistas para discutir sus necesidades de acero.",
    
    // About Page
    strategicFacilities: "Instalaciones de producción estratégicas que sirven a los principales mercados europeos.",
    productionPlant: "Planta de Producción",
    ourHistory: "Nuestra Historia",
    historyFounded: "Fundación",
    historyFoundedDesc: "TRH Steel establecida en Sevilla, España",
    historyExpansion: "Expansión",
    historyExpansionDesc: "Primera gran ampliación de línea de producción",
    historyBelgium: "Bélgica",
    historyBelgiumDesc: "Apertura de la planta de producción de Lieja",
    historySustainability: "Sostenibilidad",
    historySustainabilityDesc: "30% energía renovable alcanzada",
    historyToday: "Hoy",
    historyTodayDesc: "8 líneas de producción, capacidad de 400K toneladas",
    
    // Sustainability Page - Stat Labels
    renewable: "Renovable",
    wasteReduction: "Reducción de Residuos",
    certifiedSuppliers: "Proveedores Certificados",
    recyclingRate: "Tasa de Reciclaje",
    co2Reduction: "Reducción de CO2",
    
    // Sustainability Page - Commitment Section
    ourCommitment: "Nuestro Compromiso",
    buildingSustainableFuture: "Construyendo un Futuro Sostenible",
    sustainabilityCommitmentP1: "En TRH Steel, la sostenibilidad no es solo un objetivo, es un principio fundamental que guía cada decisión que tomamos. Desde la energía que utilizamos hasta los materiales que obtenemos, estamos comprometidos a minimizar nuestro impacto ambiental mientras maximizamos el valor para nuestros clientes.",
    sustainabilityCommitmentP2: "Nuestro enfoque de economía circular garantiza que el acero, un material infinitamente reciclable, permanezca como parte de un sistema de circuito cerrado, reduciendo los residuos y conservando los recursos naturales para las generaciones futuras.",
    carbonNeutral: "Carbono Neutral",
    
    // Sustainability Page - 2030 Goals
    our2030Goals: "Nuestros Objetivos 2030",
    goalsSubtitle: "Metas ambiciosas que impulsan nuestro camino hacia la sostenibilidad.",
    co2ReductionGoal: "Reducción de CO2",
    from2020Baseline: "Desde la base de 2020",
    circularSteel: "Acero Circular",
    recycledContentTarget: "Objetivo de contenido reciclado",
    zeroWaste: "Cero",
    wasteToLandfill: "Residuos a Vertedero",
    fullCircularity: "Circularidad total",
    
    // News Page
    categorySustainability: "Sostenibilidad",
    categoryCorporate: "Corporativo",
    categoryQuality: "Calidad",
    categoryMarket: "Mercado",
    categoryProduct: "Producto",
    byAuthor: "Por",
    
    // Contact Page - Locations
    sevilleSpain: "Sevilla, España",
    sevilleLocationName: "TRH ZF Sevilla",
    liegeLocationName: "TRH Liege",
    liegeBelgium: "Lieja, Bélgica",
    sending: "Enviando...",
    
    // Footer Locations
    footerSeville: "Sevilla, España",
    footerLiege: "Lieja, Bélgica",
    
    // Product Inquiry Modal
    productInquirySubtitle: "Solicitar información sobre este producto",
    thankYouTitle: "¡Gracias!",
    thankYouMessage: "Su mensaje ha sido enviado correctamente. Nos pondremos en contacto pronto.",
  },
  fr: {
    // Navigation
    home: "Accueil",
    aboutUs: "À Propos",
    products: "Produits",
    sustainability: "Durabilité",
    quality: "Qualité",
    news: "Actualités",
    contact: "Contact",
    
    // Private Area
    privateArea: "Espace Privé",
    privateTransporters: "Transporteurs",
    privatePurchases: "Achats",
    privateEcommerce: "E-Commerce",
    privateClients: "Clients",
    privateLogin: "Connexion Espace Privé",
    privateLoginSubtitle: "Accédez à votre compte",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    login: "Connexion",
    logout: "Déconnexion",
    loginError: "Identifiants invalides",
    welcome: "Bienvenue",
    userManagement: "Gestion des Utilisateurs",
    createUser: "Créer Utilisateur",
    userList: "Liste des Utilisateurs",
    userType: "Type d'Utilisateur",
    actions: "Actions",
    delete: "Supprimer",
    userCreated: "Utilisateur créé avec succès",
    userDeleted: "Utilisateur supprimé avec succès",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet utilisateur?",
    noUsers: "Aucun utilisateur trouvé",
    adminPanel: "Panneau d'Administration",
    backToPortal: "Retour au Portail",
    
    // Hero
    heroSlide1: "30 ans à transformer l'acier pour la construction en Europe",
    heroSlide2: "Technologie, capacité et fiabilité dans chaque mètre d'acier",
    heroSlide3: "Logistique optimisée pour des livraisons rapides et sécurisées",
    heroSlide4: "Construire l'avenir avec nos clients",
    heroSlide5: "La durabilité comme pilier de notre industrie",
    ourProducts: "Nos Produits",
    talkToSpecialist: "Parler à un Spécialiste",
    
    // About
    aboutTitle: "À Propos de TRH Steel",
    aboutSubtitle: "Acier européen, engagement durable",
    aboutDescription: "TRH est un groupe industriel spécialisé dans la transformation de l'acier pour la production de treillis soudé et produits associés. Nous exploitons deux usines stratégiquement situées dans le sud et le nord de l'Europe, nous permettant de garantir un approvisionnement fiable et efficace à nos clients.",
    ourPresence: "Notre Présence Industrielle",
    plants: "Usines de Production",
    productionLines: "Lignes de Production",
    annualCapacity: "Capacité Annuelle",
    tons: "tonnes",
    marketsServed: "Marchés Desservis",
    ourValues: "Nos Valeurs",
    reliability: "Fiabilité",
    reliabilityDesc: "Approvisionnement constant et respect des délais de livraison.",
    consistency: "Qualité",
    consistencyDesc: "Des produits conformes aux standards du marché de manière constante.",
    flexibility: "Flexibilité",
    flexibilityDesc: "Capacité d'adaptation aux exigences spécifiques de chaque client et projet.",
    longTermVision: "Engagement",
    longTermVisionDesc: "Approche orientée client et amélioration continue des processus.",
    
    // Products
    productsTitle: "Nos Produits",
    productsSubtitle: "Solutions acier pour la construction",
    allFamilies: "Toutes les Familles",
    allCountries: "Tous les Pays",
    specifications: "Spécifications",
    downloadDatasheet: "Télécharger la Fiche Technique",
    viewDetails: "Voir Détails",
    
    // Sustainability
    sustainabilityTitle: "Durabilité",
    sustainabilitySubtitle: "TRH Steel, engagé pour une industrie sidérurgique plus efficace et circulaire",
    renewableEnergy: "Énergie Renouvelable",
    renewableEnergyDesc: "Nos usines fonctionnent avec des sources d'énergie 30% renouvelables.",
    productOptimization: "Optimisation des Produits",
    productOptimizationDesc: "Maximiser l'efficacité des matériaux dans chaque processus de production.",
    responsibleMaterials: "Matières Premières Responsables",
    responsibleMaterialsDesc: "Approvisionnement auprès de fournisseurs certifiés et éthiques.",
    wasteManagement: "Gestion des Déchets et Circularité",
    wasteManagementDesc: "Mise en place de systèmes de recyclage en boucle fermée.",
    efficientLogistics: "Logistique Efficace",
    efficientLogisticsDesc: "Routes optimisées et expéditions consolidées.",
    compliance: "Conformité Réglementaire",
    complianceDesc: "Respecter et dépasser les normes environnementales.",
    
    // Quality
    qualityTitle: "Qualité",
    qualitySubtitle: "La qualité est un processus intégré, pas seulement une certification",
    qualityPolicy: "Politique Qualité",
    qualityPolicyDesc: "Notre engagement envers l'excellence guide chaque aspect de nos opérations, de la sélection des matières premières à la livraison finale.",
    controlTraceability: "Contrôle et Traçabilité",
    controlTraceabilityDesc: "Traçabilité complète des produits de l'origine à la livraison avec des systèmes de suivi en temps réel.",
    testingLabs: "Laboratoires Internes",
    testingLabsDesc: "Contrôle continu de la matière première au produit fini, garantissant la conformité aux normes requises.",
    continuousImprovement: "Amélioration Continue",
    continuousImprovementDesc: "Optimisation continue des processus et systèmes pour de meilleurs résultats.",
    ourCertificates: "Nos Certificats",
    corporateCertificates: "Certificats Entreprise",
    productCertificates: "Certificats Produits",
    validUntil: "Valide jusqu'au",
    
    // News
    newsTitle: "Actualités",
    newsSubtitle: "Dernières nouvelles de TRH Steel",
    readMore: "Lire la Suite",
    
    // News Management (Admin)
    newsManagement: "Gestion des Actualités",
    importDefaults: "Importer par Défaut",
    newArticle: "Nouvel Article",
    editArticle: "Modifier l'Article",
    noNewsInDb: "Aucun article dans la base de données.",
    clickImportDefaults: 'Cliquez sur "Importer par Défaut" pour ajouter les articles exemples.',
    titleColumn: "Titre",
    categoryColumn: "Catégorie",
    dateColumn: "Date",
    statusColumn: "Statut",
    actionsColumn: "Actions",
    noTitle: "Sans titre",
    published: "Publiée",
    draft: "Brouillon",
    articleTitle: "Titre",
    articleTitlePlaceholder: "Titre de l'article",
    articleSummary: "Résumé",
    articleSummaryPlaceholder: "Bref résumé de l'article",
    articleContent: "Contenu",
    articleContentPlaceholder: "Contenu complet de l'article",
    publicationDate: "Date de Publication",
    author: "Auteur",
    authorPlaceholder: "Nom de l'auteur",
    newsImages: "Images de l'Article",
    uploadingImage: "Téléchargement en cours...",
    clickToUploadImages: "Cliquez pour joindre des images",
    imageFormats: "PNG, JPG, WEBP (max 5Mo)",
    setAsMainImage: "Définir comme image principale",
    deleteImage: "Supprimer l'image",
    mainImage: "Principale",
    cancel: "Annuler",
    saveChanges: "Enregistrer",
    createArticle: "Créer l'Article",
    
    // Contact
    contactTitle: "Contact",
    contactSubtitle: "Contactez notre équipe",
    generalInquiries: "Demandes Générales",
    sendMessage: "Envoyer le Message",
    yourName: "Votre Nom",
    yourEmail: "Votre Email",
    company: "Entreprise",
    country: "Pays",
    phone: "Téléphone",
    subject: "Sujet",
    message: "Message",
    selectCountry: "Sélectionnez un pays",
    ourLocations: "Nos Emplacements",
    messageSent: "Message envoyé avec succès!",
    messageError: "Erreur lors de l'envoi du message. Veuillez réessayer.",
    joinOurTeam: "Rejoignez Notre Équipe",
    joinOurTeamDesc: "Nous recherchons des professionnels talentueux pour renforcer notre équipe industrielle à travers l'Europe.",
    cvUpload: "Télécharger CV",
    cvUploadHint: "PDF, DOC ou DOCX (max 5Mo)",
    sendApplication: "Envoyer la Candidature",
    applicationSent: "Candidature envoyée avec succès!",
    applicationError: "Erreur lors de l'envoi. Veuillez réessayer.",
    transportPartners: "Êtes-vous Transporteur?",
    transportPartnersDesc: "Nous collaborons avec des entreprises de transport à travers l'Europe pour assurer la livraison fiable de nos produits sidérurgiques.",
    companyName: "Nom de l'Entreprise",
    contactPerson: "Personne de Contact",
    coverageArea: "Zone de Couverture",
    coverageAreaPlaceholder: "ex. Espagne, France, Benelux...",
    fleetDescription: "Description de la Flotte",
    fleetDescriptionPlaceholder: "Nombre de véhicules, types, capacité...",
    becomePartner: "Devenir Transporteur Partenaire",
    partnerSent: "Demande de partenariat envoyée avec succès!",
    partnerError: "Erreur lors de l'envoi. Veuillez réessayer.",
    loadingHours: "Horaires de Chargement",
    loadingHoursDesc: "Nos installations sont ouvertes au chargement aux horaires suivants:",
    
    // Footer
    footerTagline: "Acier européen, engagement durable. Plus de 30 ans à construire ensemble.",
    legalNotice: "Mentions Légales",
    privacyPolicy: "Politique de Confidentialité",
    cookies: "Politique des Cookies",
    generalTerms: "Conditions Générales",
    allRightsReserved: "Tous droits réservés",
    
    // Chatbot
    chatbotTitle: "Assistant TRH Steel",
    chatbotPlaceholder: "Posez vos questions sur nos produits, services...",
    chatbotWelcome: "Bonjour! Je suis l'assistant virtuel de TRH Steel. Comment puis-je vous aider aujourd'hui?",
    
    // Countries
    spain: "Espagne",
    portugal: "Portugal",
    france: "France",
    belgium: "Belgique",
    netherlands: "Pays-Bas",
    germany: "Allemagne",
    
    // Home Page Stats
    yearsExperience: "Années d'Expérience",
    
    // Products Page
    weldedMesh: "Treillis Soudé",
    newBadge: "NOUVEAU",
    filter: "Filtrer",
    productTableProduct: "Produit",
    productTableFamily: "Famille",
    productTableCountries: "Pays",
    productTableStandard: "Norme",
    productTableActions: "Actions",
    details: "Détails",
    availableIn: "Disponible en",
    close: "Fermer",
    
    // Country Selector
    selectCountryTitle: "Sélectionnez votre pays pour voir les produits disponibles",
    productAvailabilityNote: "La disponibilité des produits varie selon le marché",
    selectYourCountry: "Sélectionnez votre pays",
    selectedCountry: "Pays sélectionné",
    changeCountry: "Changer de pays",
    clearSelection: "Effacer la sélection",
    availableProductsIn: "Produits disponibles en",
    allProductCategories: "Toutes les Catégories de Produits",
    selectCountryToFilter: "Sélectionnez un pays ci-dessus pour filtrer les produits par disponibilité",
    noProductsAvailable: "Aucun produit disponible pour cette sélection",
    comingSoon: "Bientôt Disponible",
    placeholderProductNote: "Cette catégorie de produit sera bientôt disponible. Laissez vos coordonnées et nous vous contacterons.",
    
    // Footer
    legal: "Mentions légales",
    
    // Quality Page - Every Meter Tested
    everyMeterTested: "Contrôle Qualité",
    everyMeterTestedDesc: "Nous exploitons des laboratoires internes où un contrôle continu est effectué de la matière première au produit fini, garantissant que nos produits répondent aux normes de qualité requises.",
    tensileTesting: "Essai de Traction",
    chemicalAnalysis: "Analyse Chimique",
    dimensionalCheck: "Contrôle Dimensionnel",
    batchTraceability: "Traçabilité des Lots",
    
    // Cookie Policy
    optional: "Optionnel",
    required: "Requis",
    retention: "Rétention",
    
    // Legal Notice
    legalName: "Dénomination Sociale",
    
    // Quality Page - dates
    undefined: "Indéfini",
    
    // Home Page - Contact CTA
    readyToWork: "Prêts à Travailler Ensemble?",
    whyTrhSteel: "Pourquoi TRH Steel",
    whyTrhSteelDesc: "Un groupe sidérurgique industriel européen avec une structure claire et une vision à long terme.",
    sustainabilityHomeDesc: "Notre engagement envers la durabilité guide chaque aspect de nos opérations, de l'utilisation d'énergies renouvelables à la gestion des déchets et à la logistique efficace.",
    circularEconomy: "Économie Circulaire",
    circularEconomyDesc: "Systèmes de recyclage en boucle fermée et de gestion des déchets",
    since: "Depuis",
    catalogTitle: "Catalogue Corporatif",
    catalogNav: "Catalogue",
    catalogDescription: "Téléchargez notre catalogue avec les informations complètes sur les produits, spécifications techniques et certifications. Disponible en 5 langues.",
    downloadPdf: "Télécharger",
    readyToWorkDesc: "Contactez notre équipe de spécialistes pour discuter de vos besoins en acier.",
    
    // About Page
    strategicFacilities: "Installations de production stratégiques au service des principaux marchés européens.",
    productionPlant: "Usine de Production",
    ourHistory: "Notre Histoire",
    historyFounded: "Fondation",
    historyFoundedDesc: "TRH Steel établie à Séville, Espagne",
    historyExpansion: "Expansion",
    historyExpansionDesc: "Première grande extension de ligne de production",
    historyBelgium: "Belgique",
    historyBelgiumDesc: "Ouverture de l'usine de production de Liège",
    historySustainability: "Durabilité",
    historySustainabilityDesc: "30% énergie renouvelable atteinte",
    historyToday: "Aujourd'hui",
    historyTodayDesc: "8 lignes de production, capacité de 300K tonnes",
    
    // Sustainability Page - Stat Labels
    renewable: "Renouvelable",
    wasteReduction: "Réduction des Déchets",
    certifiedSuppliers: "Fournisseurs Certifiés",
    recyclingRate: "Taux de Recyclage",
    co2Reduction: "Réduction de CO2",
    
    // Sustainability Page - Commitment Section
    ourCommitment: "Notre Engagement",
    buildingSustainableFuture: "Construire un Avenir Durable",
    sustainabilityCommitmentP1: "Chez TRH Steel, la durabilité n'est pas seulement un objectif, c'est un principe fondamental qui guide chaque décision que nous prenons. De l'énergie que nous utilisons aux matériaux que nous nous procurons, nous nous engageons à minimiser notre impact environnemental tout en maximisant la valeur pour nos clients.",
    sustainabilityCommitmentP2: "Notre approche d'économie circulaire garantit que l'acier, un matériau infiniment recyclable, reste partie d'un système en boucle fermée, réduisant les déchets et préservant les ressources naturelles pour les générations futures.",
    carbonNeutral: "Carbone Neutre",
    
    // Sustainability Page - 2030 Goals
    our2030Goals: "Nos Objectifs 2030",
    goalsSubtitle: "Des objectifs ambitieux qui guident notre parcours de durabilité.",
    co2ReductionGoal: "Réduction de CO2",
    from2020Baseline: "Par rapport à 2020",
    circularSteel: "Acier Circulaire",
    recycledContentTarget: "Objectif de contenu recyclé",
    zeroWaste: "Zéro",
    wasteToLandfill: "Déchets en Décharge",
    fullCircularity: "Circularité totale",
    
    // News Page
    categorySustainability: "Durabilité",
    categoryCorporate: "Entreprise",
    categoryQuality: "Qualité",
    categoryMarket: "Marché",
    categoryProduct: "Produit",
    byAuthor: "Par",
    
    // Contact Page - Locations
    sevilleSpain: "Séville, Espagne",
    sevilleLocationName: "TRH ZF Sevilla",
    liegeLocationName: "TRH Liege",
    liegeBelgium: "Liège, Belgique",
    sending: "Envoi en cours...",
    
    // Footer Locations
    footerSeville: "Séville, Espagne",
    footerLiege: "Liège, Belgique",
    
    // Product Inquiry Modal
    productInquirySubtitle: "Demander des informations sur ce produit",
    thankYouTitle: "Merci !",
    thankYouMessage: "Votre message a été envoyé avec succès. Nous vous contacterons bientôt.",
  },
  de: {
    // Navigation
    home: "Startseite",
    aboutUs: "Über Uns",
    products: "Produkte",
    sustainability: "Nachhaltigkeit",
    quality: "Qualität",
    news: "Neuigkeiten",
    contact: "Kontakt",
    
    // Private Area
    privateArea: "Privatbereich",
    privateTransporters: "Transporteure",
    privatePurchases: "Einkauf",
    privateEcommerce: "E-Commerce",
    privateClients: "Kunden",
    privateLogin: "Privatbereich Anmeldung",
    privateLoginSubtitle: "Greifen Sie auf Ihr Konto zu",
    username: "Benutzername",
    password: "Passwort",
    login: "Anmelden",
    logout: "Abmelden",
    loginError: "Ungültige Anmeldedaten",
    welcome: "Willkommen",
    userManagement: "Benutzerverwaltung",
    createUser: "Benutzer Erstellen",
    userList: "Benutzerliste",
    userType: "Benutzertyp",
    actions: "Aktionen",
    delete: "Löschen",
    userCreated: "Benutzer erfolgreich erstellt",
    userDeleted: "Benutzer erfolgreich gelöscht",
    confirmDelete: "Möchten Sie diesen Benutzer wirklich löschen?",
    noUsers: "Keine Benutzer gefunden",
    adminPanel: "Admin-Panel",
    backToPortal: "Zurück zum Portal",
    
    // Hero
    heroSlide1: "30 Jahre Stahltransformation für den Bau in Europa",
    heroSlide2: "Technologie, Kapazität und Zuverlässigkeit in jedem Meter Stahl",
    heroSlide3: "Optimierte Logistik für schnelle und sichere Lieferungen",
    heroSlide4: "Gemeinsam mit unseren Kunden die Zukunft bauen",
    heroSlide5: "Nachhaltigkeit als Säule unserer Industrie",
    ourProducts: "Unsere Produkte",
    talkToSpecialist: "Mit einem Spezialisten sprechen",
    
    // About
    aboutTitle: "Über TRH Steel",
    aboutSubtitle: "Europäischer Stahl, nachhaltiges Engagement",
    aboutDescription: "Seit 1998 ist TRH Steel ein führender europäischer Hersteller und Händler von Stahlprodukten für den Bausektor. Mit mehr als 30 Jahren Erfahrung verbinden wir industrielle Exzellenz mit einem Engagement für Nachhaltigkeit.",
    ourPresence: "Unsere Industrielle Präsenz",
    plants: "Produktionswerke",
    productionLines: "Produktionslinien",
    annualCapacity: "Jahreskapazität",
    tons: "Tonnen",
    marketsServed: "Bediente Märkte",
    ourValues: "Unsere Werte",
    reliability: "Zuverlässigkeit",
    reliabilityDesc: "Konstante Versorgung und termingerechte Lieferleistung.",
    consistency: "Qualität",
    consistencyDesc: "Produkte, die konsequent die Marktstandards erfüllen.",
    flexibility: "Flexibilität",
    flexibilityDesc: "Fähigkeit, sich an spezifische Kunden- und Projektanforderungen anzupassen.",
    longTermVision: "Engagement",
    longTermVisionDesc: "Kundenorientierter Ansatz und kontinuierliche Prozessverbesserung.",
    
    // Products
    productsTitle: "Unsere Produkte",
    productsSubtitle: "Stahllösungen für den Bau",
    allFamilies: "Alle Familien",
    allCountries: "Alle Länder",
    specifications: "Spezifikationen",
    downloadDatasheet: "Datenblatt Herunterladen",
    viewDetails: "Details Anzeigen",
    
    // Sustainability
    sustainabilityTitle: "Nachhaltigkeit",
    sustainabilitySubtitle: "TRH Steel, engagiert für eine effizientere und zirkuläre Stahlindustrie",
    renewableEnergy: "Erneuerbare Energie",
    renewableEnergyDesc: "Unsere Werke arbeiten mit 30% erneuerbaren Energiequellen.",
    productOptimization: "Produktoptimierung",
    productOptimizationDesc: "Maximierung der Materialeffizienz in jedem Produktionsprozess.",
    responsibleMaterials: "Verantwortungsvolle Rohstoffe",
    responsibleMaterialsDesc: "Beschaffung von Materialien von zertifizierten und ethischen Lieferanten.",
    wasteManagement: "Abfallmanagement & Kreislaufwirtschaft",
    wasteManagementDesc: "Implementierung geschlossener Recyclingsysteme.",
    efficientLogistics: "Effiziente Logistik",
    efficientLogisticsDesc: "Optimierte Routen und konsolidierte Sendungen.",
    compliance: "Regulatorische Compliance",
    complianceDesc: "Erfüllung und Übertreffen von Umweltstandards.",
    
    // Quality
    qualityTitle: "Qualität",
    qualitySubtitle: "Qualität ist ein integrierter Prozess, nicht nur eine Zertifizierung",
    qualityPolicy: "Qualitätspolitik",
    qualityPolicyDesc: "Unser Engagement für Exzellenz treibt jeden Aspekt unserer Operationen an, von der Rohstoffauswahl bis zur Endlieferung.",
    controlTraceability: "Kontrolle & Rückverfolgbarkeit",
    controlTraceabilityDesc: "Vollständige Produktrückverfolgbarkeit vom Ursprung bis zur Lieferung mit Echtzeit-Tracking-Systemen.",
    testingLabs: "Interne Labore",
    testingLabsDesc: "Kontinuierliche Kontrolle vom Rohstoff bis zum Endprodukt, die die Einhaltung der geforderten Standards gewährleistet.",
    continuousImprovement: "Kontinuierliche Verbesserung",
    continuousImprovementDesc: "Laufende Optimierung von Prozessen und Systemen für bessere Ergebnisse.",
    ourCertificates: "Unsere Zertifikate",
    corporateCertificates: "Unternehmenszertifikate",
    productCertificates: "Produktzertifikate",
    validUntil: "Gültig bis",
    
    // News
    newsTitle: "Neuigkeiten",
    newsSubtitle: "Aktuelle Nachrichten von TRH Steel",
    readMore: "Weiterlesen",
    
    // News Management (Admin)
    newsManagement: "Nachrichtenverwaltung",
    importDefaults: "Standards Importieren",
    newArticle: "Neuer Artikel",
    editArticle: "Artikel Bearbeiten",
    noNewsInDb: "Keine Artikel in der Datenbank.",
    clickImportDefaults: 'Klicken Sie auf "Standards Importieren", um die Beispielartikel hinzuzufügen.',
    titleColumn: "Titel",
    categoryColumn: "Kategorie",
    dateColumn: "Datum",
    statusColumn: "Status",
    actionsColumn: "Aktionen",
    noTitle: "Kein Titel",
    published: "Veröffentlicht",
    draft: "Entwurf",
    articleTitle: "Titel",
    articleTitlePlaceholder: "Artikeltitel",
    articleSummary: "Zusammenfassung",
    articleSummaryPlaceholder: "Kurze Zusammenfassung des Artikels",
    articleContent: "Inhalt",
    articleContentPlaceholder: "Vollständiger Artikelinhalt",
    publicationDate: "Veröffentlichungsdatum",
    author: "Autor",
    authorPlaceholder: "Name des Autors",
    newsImages: "Artikelbilder",
    uploadingImage: "Bild wird hochgeladen...",
    clickToUploadImages: "Klicken Sie, um Bilder anzuhängen",
    imageFormats: "PNG, JPG, WEBP (max 5MB)",
    setAsMainImage: "Als Hauptbild festlegen",
    deleteImage: "Bild löschen",
    mainImage: "Hauptbild",
    cancel: "Abbrechen",
    saveChanges: "Änderungen Speichern",
    createArticle: "Artikel Erstellen",
    
    // Contact
    contactTitle: "Kontakt",
    contactSubtitle: "Kontaktieren Sie unser Team",
    generalInquiries: "Allgemeine Anfragen",
    sendMessage: "Nachricht Senden",
    yourName: "Ihr Name",
    yourEmail: "Ihre E-Mail",
    company: "Unternehmen",
    country: "Land",
    phone: "Telefon",
    subject: "Betreff",
    message: "Nachricht",
    selectCountry: "Wählen Sie ein Land",
    ourLocations: "Unsere Standorte",
    messageSent: "Nachricht erfolgreich gesendet!",
    messageError: "Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.",
    joinOurTeam: "Werden Sie Teil Unseres Teams",
    joinOurTeamDesc: "Wir suchen talentierte Fachkräfte zur Verstärkung unseres Industrieteams in ganz Europa.",
    cvUpload: "Lebenslauf Hochladen",
    cvUploadHint: "PDF, DOC oder DOCX (max. 5MB)",
    sendApplication: "Bewerbung Senden",
    applicationSent: "Bewerbung erfolgreich gesendet!",
    applicationError: "Fehler beim Senden. Bitte versuchen Sie es erneut.",
    transportPartners: "Sind Sie Transportpartner?",
    transportPartnersDesc: "Wir arbeiten mit Transportunternehmen in ganz Europa zusammen, um die zuverlässige Lieferung unserer Stahlprodukte sicherzustellen.",
    companyName: "Firmenname",
    contactPerson: "Ansprechpartner",
    coverageArea: "Abdeckungsgebiet",
    coverageAreaPlaceholder: "z.B. Spanien, Frankreich, Benelux...",
    fleetDescription: "Flottenbeschreibung",
    fleetDescriptionPlaceholder: "Anzahl Fahrzeuge, Typen, Kapazität...",
    becomePartner: "Transportpartner Werden",
    partnerSent: "Partnerantrag erfolgreich gesendet!",
    partnerError: "Fehler beim Senden. Bitte versuchen Sie es erneut.",
    loadingHours: "Verladezeiten",
    loadingHoursDesc: "Unsere Anlagen sind zu folgenden Zeiten für die Verladung geöffnet:",
    
    // Footer
    footerTagline: "Europäischer Stahl, nachhaltiges Engagement. Mehr als 30 Jahre gemeinsames Bauen.",
    legalNotice: "Impressum",
    privacyPolicy: "Datenschutzerklärung",
    cookies: "Cookie-Richtlinie",
    generalTerms: "Allgemeine Geschäftsbedingungen",
    allRightsReserved: "Alle Rechte vorbehalten",
    
    // Chatbot
    chatbotTitle: "TRH Steel Assistent",
    chatbotPlaceholder: "Fragen Sie nach unseren Produkten, Dienstleistungen...",
    chatbotWelcome: "Hallo! Ich bin der virtuelle Assistent von TRH Steel. Wie kann ich Ihnen heute helfen?",
    
    // Countries
    spain: "Spanien",
    portugal: "Portugal",
    france: "Frankreich",
    belgium: "Belgien",
    netherlands: "Niederlande",
    germany: "Deutschland",
    
    // Home Page Stats
    yearsExperience: "Jahre Erfahrung",
    
    // Products Page
    weldedMesh: "Geschweißte Matten",
    newBadge: "NEU",
    filter: "Filtern",
    productTableProduct: "Produkt",
    productTableFamily: "Familie",
    productTableCountries: "Länder",
    productTableStandard: "Norm",
    productTableActions: "Aktionen",
    details: "Details",
    availableIn: "Verfügbar in",
    close: "Schließen",
    
    // Country Selector
    selectCountryTitle: "Wählen Sie Ihr Land, um verfügbare Produkte anzuzeigen",
    productAvailabilityNote: "Die Produktverfügbarkeit variiert je nach Markt",
    selectYourCountry: "Wählen Sie Ihr Land",
    selectedCountry: "Ausgewähltes Land",
    changeCountry: "Land ändern",
    clearSelection: "Auswahl löschen",
    availableProductsIn: "Verfügbare Produkte in",
    allProductCategories: "Alle Produktkategorien",
    selectCountryToFilter: "Wählen Sie oben ein Land, um Produkte nach Verfügbarkeit zu filtern",
    noProductsAvailable: "Keine Produkte für diese Auswahl verfügbar",
    comingSoon: "Demnächst",
    placeholderProductNote: "Diese Produktkategorie wird bald verfügbar sein. Hinterlassen Sie Ihre Daten und wir werden Sie kontaktieren.",
    
    // Footer
    legal: "Rechtliches",
    
    // Quality Page - Every Meter Tested
    everyMeterTested: "Qualitätskontrolle",
    everyMeterTestedDesc: "Wir betreiben interne Labore, in denen eine kontinuierliche Kontrolle vom Rohstoff bis zum Endprodukt durchgeführt wird, um sicherzustellen, dass unsere Produkte die geforderten Qualitätsstandards erfüllen.",
    tensileTesting: "Zugprüfung",
    chemicalAnalysis: "Chemische Analyse",
    dimensionalCheck: "Maßkontrolle",
    batchTraceability: "Chargenrückverfolgbarkeit",
    
    // Cookie Policy
    optional: "Optional",
    required: "Erforderlich",
    retention: "Aufbewahrung",
    
    // Legal Notice
    legalName: "Firmenname",
    
    // Quality Page - dates
    undefined: "Unbegrenzt",
    
    // Home Page - Contact CTA
    readyToWork: "Bereit zur Zusammenarbeit?",
    whyTrhSteel: "Warum TRH Steel",
    whyTrhSteelDesc: "Eine europäische Industriestahlgruppe mit klarer Struktur und langfristiger Vision.",
    sustainabilityHomeDesc: "Unser Engagement für Nachhaltigkeit bestimmt jeden Aspekt unserer Geschäftstätigkeit, von der Nutzung erneuerbarer Energien über die Abfallwirtschaft bis hin zur effizienten Logistik.",
    circularEconomy: "Kreislaufwirtschaft",
    circularEconomyDesc: "Geschlossene Recycling- und Abfallmanagementsysteme",
    since: "Seit",
    catalogTitle: "Unternehmenskatalog",
    catalogNav: "Katalog",
    catalogDescription: "Laden Sie unseren Katalog mit vollständigen Produktinformationen, technischen Spezifikationen und Zertifizierungen herunter. Verfügbar in 5 Sprachen.",
    downloadPdf: "Herunterladen",
    readyToWorkDesc: "Kontaktieren Sie unser Spezialistenteam, um Ihre Stahlanforderungen zu besprechen.",
    
    // About Page
    strategicFacilities: "Strategische Produktionsanlagen für wichtige europäische Märkte.",
    productionPlant: "Produktionswerk",
    ourHistory: "Unsere Geschichte",
    historyFounded: "Gründung",
    historyFoundedDesc: "TRH Steel in Sevilla, Spanien gegründet",
    historyExpansion: "Expansion",
    historyExpansionDesc: "Erste große Produktionslinienerweiterung",
    historyBelgium: "Belgien",
    historyBelgiumDesc: "Eröffnung der Produktionsanlage in Lüttich",
    historySustainability: "Nachhaltigkeit",
    historySustainabilityDesc: "30% erneuerbare Energie erreicht",
    historyToday: "Heute",
    historyTodayDesc: "8 Produktionslinien, 400K Tonnen Kapazität",
    
    // Sustainability Page - Stat Labels
    renewable: "Erneuerbar",
    wasteReduction: "Abfallreduzierung",
    certifiedSuppliers: "Zertifizierte Lieferanten",
    recyclingRate: "Recyclingrate",
    co2Reduction: "CO2-Reduzierung",
    
    // Sustainability Page - Commitment Section
    ourCommitment: "Unser Engagement",
    buildingSustainableFuture: "Eine nachhaltige Zukunft aufbauen",
    sustainabilityCommitmentP1: "Bei TRH Steel ist Nachhaltigkeit nicht nur ein Ziel – es ist ein grundlegendes Prinzip, das jede Entscheidung leitet, die wir treffen. Von der Energie, die wir nutzen, bis zu den Materialien, die wir beschaffen, setzen wir uns dafür ein, unsere Umweltauswirkungen zu minimieren und gleichzeitig den Wert für unsere Kunden zu maximieren.",
    sustainabilityCommitmentP2: "Unser Kreislaufwirtschaftsansatz stellt sicher, dass Stahl – ein unendlich recycelbares Material – Teil eines geschlossenen Systems bleibt, Abfall reduziert und natürliche Ressourcen für zukünftige Generationen erhält.",
    carbonNeutral: "CO2-Neutral",
    
    // Sustainability Page - 2030 Goals
    our2030Goals: "Unsere Ziele 2030",
    goalsSubtitle: "Ehrgeizige Ziele, die unseren Nachhaltigkeitsweg vorantreiben.",
    co2ReductionGoal: "CO2-Reduzierung",
    from2020Baseline: "Gegenüber Basis 2020",
    circularSteel: "Kreislaufstahl",
    recycledContentTarget: "Ziel für Recyclinganteil",
    zeroWaste: "Null",
    wasteToLandfill: "Abfall auf Deponien",
    fullCircularity: "Volle Kreislaufwirtschaft",
    
    // News Page
    categorySustainability: "Nachhaltigkeit",
    categoryCorporate: "Unternehmen",
    categoryQuality: "Qualität",
    categoryMarket: "Markt",
    categoryProduct: "Produkt",
    byAuthor: "Von",
    
    // Contact Page - Locations
    sevilleSpain: "Sevilla, Spanien",
    sevilleLocationName: "TRH ZF Sevilla",
    liegeLocationName: "TRH Liege",
    liegeBelgium: "Lüttich, Belgien",
    sending: "Wird gesendet...",
    
    // Footer Locations
    footerSeville: "Sevilla, Spanien",
    footerLiege: "Lüttich, Belgien",
    
    // Product Inquiry Modal
    productInquirySubtitle: "Informationen zu diesem Produkt anfordern",
    thankYouTitle: "Danke!",
    thankYouMessage: "Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns bald bei Ihnen melden.",
  },
  nl: {
    // Navigation
    home: "Home",
    aboutUs: "Over Ons",
    products: "Producten",
    sustainability: "Duurzaamheid",
    quality: "Kwaliteit",
    news: "Nieuws",
    contact: "Contact",
    
    // Private Area
    privateArea: "Privézone",
    privateTransporters: "Transporteurs",
    privatePurchases: "Inkoop",
    privateEcommerce: "E-Commerce",
    privateClients: "Klanten",
    privateLogin: "Privézone Inloggen",
    privateLoginSubtitle: "Toegang tot uw account",
    username: "Gebruikersnaam",
    password: "Wachtwoord",
    login: "Inloggen",
    logout: "Uitloggen",
    loginError: "Ongeldige inloggegevens",
    welcome: "Welkom",
    userManagement: "Gebruikersbeheer",
    createUser: "Gebruiker Aanmaken",
    userList: "Gebruikerslijst",
    userType: "Gebruikerstype",
    actions: "Acties",
    delete: "Verwijderen",
    userCreated: "Gebruiker succesvol aangemaakt",
    userDeleted: "Gebruiker succesvol verwijderd",
    confirmDelete: "Weet u zeker dat u deze gebruiker wilt verwijderen?",
    noUsers: "Geen gebruikers gevonden",
    adminPanel: "Beheerpaneel",
    backToPortal: "Terug naar Portaal",
    
    // Hero
    heroSlide1: "30 jaar staal transformeren voor de bouw in Europa",
    heroSlide2: "Technologie, capaciteit en betrouwbaarheid in elke meter staal",
    heroSlide3: "Geoptimaliseerde logistiek voor snelle en veilige leveringen",
    heroSlide4: "Samen met onze klanten de toekomst bouwen",
    heroSlide5: "Duurzaamheid als pijler van onze industrie",
    ourProducts: "Onze Producten",
    talkToSpecialist: "Spreek met een Specialist",
    
    // About
    aboutTitle: "Over TRH Steel",
    aboutSubtitle: "Europees staal, duurzaam engagement",
    aboutDescription: "TRH is een industriële groep gespecialiseerd in staaltransformatie voor de productie van wapeningsnetten en aanverwante producten. We beschikken over twee strategisch gelegen productiefabrieken in Zuid- en Noord-Europa, waardoor we onze klanten een betrouwbare en efficiënte levering kunnen garanderen.",
    ourPresence: "Onze Industriële Aanwezigheid",
    plants: "Productiefabrieken",
    productionLines: "Productielijnen",
    annualCapacity: "Jaarlijkse Capaciteit",
    tons: "ton",
    marketsServed: "Bediende Markten",
    ourValues: "Onze Waarden",
    reliability: "Betrouwbaarheid",
    reliabilityDesc: "Constante levering en tijdige leveringsprestaties.",
    consistency: "Kwaliteit",
    consistencyDesc: "Producten die consequent aan de marktnormen voldoen.",
    flexibility: "Flexibiliteit",
    flexibilityDesc: "Vermogen om zich aan te passen aan specifieke klant- en projectvereisten.",
    longTermVision: "Betrokkenheid",
    longTermVisionDesc: "Klantgerichte aanpak en continue procesverbetering.",
    
    // Products
    productsTitle: "Onze Producten",
    productsSubtitle: "Staaloplossingen voor de bouw",
    allFamilies: "Alle Families",
    allCountries: "Alle Landen",
    specifications: "Specificaties",
    downloadDatasheet: "Datasheet Downloaden",
    viewDetails: "Details Bekijken",
    
    // Sustainability
    sustainabilityTitle: "Duurzaamheid",
    sustainabilitySubtitle: "TRH Steel, toegewijd aan een efficiëntere en circulaire staalindustrie",
    renewableEnergy: "Hernieuwbare Energie",
    renewableEnergyDesc: "Onze fabrieken werken met 30% hernieuwbare energiebronnen.",
    productOptimization: "Productoptimalisatie",
    productOptimizationDesc: "Maximaliseren van materiaalefficiëntie in elk productieproces.",
    responsibleMaterials: "Verantwoorde Grondstoffen",
    responsibleMaterialsDesc: "Inkoop van materialen bij gecertificeerde en ethische leveranciers.",
    wasteManagement: "Afvalbeheer & Circulariteit",
    wasteManagementDesc: "Implementatie van gesloten recyclingsystemen.",
    efficientLogistics: "Efficiënte Logistiek",
    efficientLogisticsDesc: "Geoptimaliseerde routes en geconsolideerde zendingen.",
    compliance: "Regelgevende Naleving",
    complianceDesc: "Voldoen aan en overtreffen van milieunormen.",
    
    // Quality
    qualityTitle: "Kwaliteit",
    qualitySubtitle: "Kwaliteit is een geïntegreerd proces, niet alleen een certificering",
    qualityPolicy: "Kwaliteitsbeleid",
    qualityPolicyDesc: "Onze toewijding aan excellentie drijft elk aspect van onze activiteiten, van grondstoffenselectie tot eindlevering.",
    controlTraceability: "Controle & Traceerbaarheid",
    controlTraceabilityDesc: "Volledige producttraceerbaarheid van oorsprong tot levering met real-time trackingsystemen.",
    testingLabs: "Interne Laboratoria",
    testingLabsDesc: "Continue controle van grondstof tot eindproduct, waardoor naleving van de vereiste normen wordt gegarandeerd.",
    continuousImprovement: "Continue Verbetering",
    continuousImprovementDesc: "Voortdurende optimalisatie van processen en systemen voor betere resultaten.",
    ourCertificates: "Onze Certificaten",
    corporateCertificates: "Bedrijfscertificaten",
    productCertificates: "Productcertificaten",
    validUntil: "Geldig tot",
    
    // News
    newsTitle: "Nieuws",
    newsSubtitle: "Laatste updates van TRH Steel",
    readMore: "Lees Meer",
    
    // News Management (Admin)
    newsManagement: "Nieuwsbeheer",
    importDefaults: "Standaard Importeren",
    newArticle: "Nieuw Artikel",
    editArticle: "Artikel Bewerken",
    noNewsInDb: "Geen artikelen in de database.",
    clickImportDefaults: 'Klik op "Standaard Importeren" om de voorbeeldartikelen toe te voegen.',
    titleColumn: "Titel",
    categoryColumn: "Categorie",
    dateColumn: "Datum",
    statusColumn: "Status",
    actionsColumn: "Acties",
    noTitle: "Geen titel",
    published: "Gepubliceerd",
    draft: "Concept",
    articleTitle: "Titel",
    articleTitlePlaceholder: "Artikeltitel",
    articleSummary: "Samenvatting",
    articleSummaryPlaceholder: "Korte samenvatting van het artikel",
    articleContent: "Inhoud",
    articleContentPlaceholder: "Volledige artikelinhoud",
    publicationDate: "Publicatiedatum",
    author: "Auteur",
    authorPlaceholder: "Naam van de auteur",
    newsImages: "Artikelafbeeldingen",
    uploadingImage: "Afbeelding uploaden...",
    clickToUploadImages: "Klik om afbeeldingen bij te voegen",
    imageFormats: "PNG, JPG, WEBP (max 5MB)",
    setAsMainImage: "Instellen als hoofdafbeelding",
    deleteImage: "Afbeelding verwijderen",
    mainImage: "Hoofd",
    cancel: "Annuleren",
    saveChanges: "Wijzigingen Opslaan",
    createArticle: "Artikel Aanmaken",
    
    // Contact
    contactTitle: "Contact",
    contactSubtitle: "Neem contact op met ons team",
    generalInquiries: "Algemene Vragen",
    sendMessage: "Bericht Versturen",
    yourName: "Uw Naam",
    yourEmail: "Uw E-mail",
    company: "Bedrijf",
    country: "Land",
    phone: "Telefoon",
    subject: "Onderwerp",
    message: "Bericht",
    selectCountry: "Selecteer een land",
    ourLocations: "Onze Locaties",
    messageSent: "Bericht succesvol verzonden!",
    messageError: "Fout bij het verzenden van het bericht. Probeer het opnieuw.",
    joinOurTeam: "Word Lid van Ons Team",
    joinOurTeamDesc: "Wij zijn op zoek naar getalenteerde professionals om ons industrieel team in heel Europa te versterken.",
    cvUpload: "CV Uploaden",
    cvUploadHint: "PDF, DOC of DOCX (max 5MB)",
    sendApplication: "Sollicitatie Versturen",
    applicationSent: "Sollicitatie succesvol verzonden!",
    applicationError: "Fout bij het verzenden. Probeer het opnieuw.",
    transportPartners: "Bent u Transportpartner?",
    transportPartnersDesc: "Wij werken samen met transportbedrijven in heel Europa om de betrouwbare levering van onze staalproducten te garanderen.",
    companyName: "Bedrijfsnaam",
    contactPerson: "Contactpersoon",
    coverageArea: "Dekkingsgebied",
    coverageAreaPlaceholder: "bijv. Spanje, Frankrijk, Benelux...",
    fleetDescription: "Vlootbeschrijving",
    fleetDescriptionPlaceholder: "Aantal voertuigen, types, capaciteit...",
    becomePartner: "Word Transportpartner",
    partnerSent: "Partneraanvraag succesvol verzonden!",
    partnerError: "Fout bij het verzenden. Probeer het opnieuw.",
    loadingHours: "Laadtijden",
    loadingHoursDesc: "Onze faciliteiten zijn geopend voor laden tijdens de volgende uren:",
    
    // Footer
    footerTagline: "Europees staal, duurzaam engagement. Meer dan 30 jaar samen bouwen.",
    legalNotice: "Juridische Kennisgeving",
    privacyPolicy: "Privacybeleid",
    cookies: "Cookiebeleid",
    generalTerms: "Algemene Voorwaarden",
    allRightsReserved: "Alle rechten voorbehouden",
    
    // Chatbot
    chatbotTitle: "TRH Steel Assistent",
    chatbotPlaceholder: "Vraag naar onze producten, diensten...",
    chatbotWelcome: "Hallo! Ik ben de virtuele assistent van TRH Steel. Hoe kan ik u vandaag helpen?",
    
    // Countries
    spain: "Spanje",
    portugal: "Portugal",
    france: "Frankrijk",
    belgium: "België",
    netherlands: "Nederland",
    germany: "Duitsland",
    
    // Home Page Stats
    yearsExperience: "Jaar Ervaring",
    
    // Products Page
    weldedMesh: "Wapeningsnetten",
    newBadge: "NIEUW",
    filter: "Filteren",
    productTableProduct: "Product",
    productTableFamily: "Familie",
    productTableCountries: "Landen",
    productTableStandard: "Norm",
    productTableActions: "Acties",
    details: "Details",
    availableIn: "Beschikbaar in",
    close: "Sluiten",
    
    // Country Selector
    selectCountryTitle: "Selecteer uw land om beschikbare producten te bekijken",
    productAvailabilityNote: "Productbeschikbaarheid varieert per markt",
    selectYourCountry: "Selecteer uw land",
    selectedCountry: "Geselecteerd land",
    changeCountry: "Land wijzigen",
    clearSelection: "Selectie wissen",
    availableProductsIn: "Beschikbare producten in",
    allProductCategories: "Alle Productcategorieën",
    selectCountryToFilter: "Selecteer hierboven een land om producten te filteren op beschikbaarheid",
    noProductsAvailable: "Geen producten beschikbaar voor deze selectie",
    comingSoon: "Binnenkort",
    placeholderProductNote: "Deze productcategorie komt binnenkort beschikbaar. Laat uw gegevens achter en we nemen contact met u op.",
    
    // Footer
    legal: "Juridisch",
    
    // Quality Page - Every Meter Tested
    everyMeterTested: "Kwaliteitscontrole",
    everyMeterTestedDesc: "Wij beschikken over interne laboratoria waar continue controle wordt uitgevoerd van grondstof tot eindproduct, om te garanderen dat onze producten voldoen aan de vereiste kwaliteitsnormen.",
    tensileTesting: "Trekproef",
    chemicalAnalysis: "Chemische Analyse",
    dimensionalCheck: "Maatcontrole",
    batchTraceability: "Partijtraceerbaarheid",
    
    // Cookie Policy
    optional: "Optioneel",
    required: "Vereist",
    retention: "Bewaring",
    
    // Legal Notice
    legalName: "Rechtspersoon",
    
    // Quality Page - dates
    undefined: "Onbepaald",
    
    // Home Page - Contact CTA
    readyToWork: "Klaar om Samen te Werken?",
    whyTrhSteel: "Waarom TRH Steel",
    whyTrhSteelDesc: "Een Europese industriële staalgroep met een duidelijke structuur en langetermijnvisie.",
    sustainabilityHomeDesc: "Onze toewijding aan duurzaamheid stuurt elk aspect van onze activiteiten, van het gebruik van hernieuwbare energie tot afvalbeheer en efficiënte logistiek.",
    circularEconomy: "Circulaire Economie",
    circularEconomyDesc: "Gesloten recycling- en afvalbeheersystemen",
    since: "Sinds",
    catalogTitle: "Bedrijfscatalogus",
    catalogNav: "Catalogus",
    catalogDescription: "Download onze catalogus met volledige productinformatie, technische specificaties en certificeringen. Beschikbaar in 5 talen.",
    downloadPdf: "Downloaden",
    readyToWorkDesc: "Neem contact op met ons team van specialisten om uw staalbehoeften te bespreken.",
    
    // About Page
    strategicFacilities: "Strategische productiefaciliteiten voor belangrijke Europese markten.",
    productionPlant: "Productiefabriek",
    ourHistory: "Onze Geschiedenis",
    historyFounded: "Opgericht",
    historyFoundedDesc: "TRH Steel opgericht in Sevilla, Spanje",
    historyExpansion: "Expansie",
    historyExpansionDesc: "Eerste grote uitbreiding productielijn",
    historyBelgium: "België",
    historyBelgiumDesc: "Opening productiefaciliteit Luik",
    historySustainability: "Duurzaamheid",
    historySustainabilityDesc: "100% hernieuwbare energie bereikt",
    historyToday: "Vandaag",
    historyTodayDesc: "8 productielijnen, 400K ton capaciteit",
    
    // Sustainability Page - Stat Labels
    renewable: "Hernieuwbaar",
    wasteReduction: "Afvalvermindering",
    certifiedSuppliers: "Gecertificeerde Leveranciers",
    recyclingRate: "Recyclingpercentage",
    co2Reduction: "CO2-reductie",
    
    // Sustainability Page - Commitment Section
    ourCommitment: "Onze Toewijding",
    buildingSustainableFuture: "Een Duurzame Toekomst Bouwen",
    sustainabilityCommitmentP1: "Bij TRH Steel is duurzaamheid niet alleen een doel – het is een fundamenteel principe dat elke beslissing die we nemen begeleidt. Van de energie die we gebruiken tot de materialen die we inkopen, we zijn toegewijd aan het minimaliseren van onze milieu-impact terwijl we de waarde voor onze klanten maximaliseren.",
    sustainabilityCommitmentP2: "Onze circulaire economie-aanpak zorgt ervoor dat staal – een oneindig recyclebaar materiaal – deel blijft van een gesloten systeem, afval vermindert en natuurlijke hulpbronnen behoudt voor toekomstige generaties.",
    carbonNeutral: "Koolstofneutraal",
    
    // Sustainability Page - 2030 Goals
    our2030Goals: "Onze Doelen 2030",
    goalsSubtitle: "Ambitieuze doelen die onze duurzaamheidsreis aandrijven.",
    co2ReductionGoal: "CO2-reductie",
    from2020Baseline: "Vanaf basis 2020",
    circularSteel: "Circulair Staal",
    recycledContentTarget: "Doel voor gerecycled gehalte",
    zeroWaste: "Nul",
    wasteToLandfill: "Afval naar Stortplaats",
    fullCircularity: "Volledige circulariteit",
    
    // News Page
    categorySustainability: "Duurzaamheid",
    categoryCorporate: "Bedrijf",
    categoryQuality: "Kwaliteit",
    categoryMarket: "Markt",
    categoryProduct: "Product",
    byAuthor: "Door",
    
    // Contact Page - Locations
    sevilleSpain: "Sevilla, Spanje",
    sevilleLocationName: "TRH ZF Sevilla",
    liegeLocationName: "TRH Liege",
    liegeBelgium: "Luik, België",
    sending: "Verzenden...",
    
    // Footer Locations
    footerSeville: "Sevilla, Spanje",
    footerLiege: "Luik, België",
    
    // Product Inquiry Modal
    productInquirySubtitle: "Informatie over dit product aanvragen",
    thankYouTitle: "Bedankt!",
    thankYouMessage: "Uw bericht is succesvol verzonden. We nemen snel contact met u op.",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('trh_language');
    if (saved && translations[saved]) return saved;
    const browserLang = navigator.language.split('-')[0];
    return translations[browserLang] ? browserLang : 'en';
  });

  const t = (key) => {
    return translations[language][key] || translations['en'][key] || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      localStorage.setItem('trh_language', lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
